import React from "react";

import { getTranslation } from "../../helpers/getLanguage";
import ConfirmationModal from "../dialogs/ConfirmationModal";
import DeletionWaitingModal from "../dialogs/DeletionWaitingModal";

export const ConfirmationModalRemovingFoldersAndProjects = ({
  deleteSelectedFoldersAndProjects,
  setModalOpen,
  type,
  pendingDeleteProject,
}) => {
  const handleClose = () => setModalOpen((prev) => ({ ...prev, deleteMany: false }));

  const handleSubmit = () => {
    deleteSelectedFoldersAndProjects();
  };

  if (pendingDeleteProject) {
    return (
      <DeletionWaitingModal
        closeDialog={handleClose}
        message={getTranslation("DELETION_WAITING_DEFAULT_MESSAGE")}
        closeOnClickOutside={false}
        closeOnEscape={false}
      />
    );
  }

  if (type === "empty") {
    return (
      <ConfirmationModal
        className="warning-delete-modal"
        closeDialog={handleClose}
        autoFocus={true}
        buttonText={"OK"}
        onConfirm={handleClose}
        message={getTranslation("CONFIRMATION_MESSAGE_TO_DELETE_FOLDERS_OR_PROJECTS")}
      />
    );
  }

  return (
    <ConfirmationModal
      className="warning-delete-modal"
      closeDialog={handleClose}
      disabled={pendingDeleteProject}
      autoFocus={true}
      buttonText={getTranslation("EDIT_ATTRIBUTE_DIALOG_BUTTON_DELETE")}
      onConfirm={handleSubmit}
      cancelButton={getTranslation("WARNING_MODAL_CANCEL_BUTTON_TEXT")}
      message={getTranslation(
        type === "single"
          ? "CONFIRM_MODAL_DELETE_MESSAGE_FOLDER_OR_PROJECT"
          : "CONFIRM_MODAL_DELETE_MESSAGE_FOLDERS_AND_PROJECTS",
      )}
    />
  );
};
